// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrap":"checkboxWrap--c98ju","dot":"dot--Pr6ud","line":"line--kRlST","link":"link--ScM86"};